
/**
 * Utilities for managing service worker and browser caches
 */

/**
 * Clear application caches if available in the browser
 */
export function clearBrowserCaches(): Promise<void> {
  if ('caches' in window) {
    return caches.keys().then(cacheNames => {
      return Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      ).then(() => {}); // Convert the Promise<boolean[]> to Promise<void>
    });
  }
  return Promise.resolve();
}

/**
 * Clear service worker caches if available
 */
export function clearServiceWorkerCaches(): Promise<void> {
  if ('caches' in window) {
    return caches.keys().then(names => {
      return Promise.all(
        names.map(name => caches.delete(name))
      ).then(() => {}); // Convert the Promise<boolean[]> to Promise<void>
    });
  }
  return Promise.resolve();
}
